import React, { useState } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { useAuth } from '../../../contexts/AuthContext';

const SocialLogin = () => {
  const { signInWithOAuth } = useAuth();
  const [loading, setLoading] = useState(null);

  const handleSocialLogin = async (provider) => {
    try {
      setLoading(provider);
      await signInWithOAuth(provider?.toLowerCase());
      // User will be redirected to OAuth provider
    } catch (error) {
      console.error(`${provider} login error:`, error?.message);
      alert(`Failed to sign in with ${provider}. Please try again.`);
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="w-full max-w-md mx-auto">
      {/* Divider */}
      <div className="relative my-8">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border/40" />
        </div>
        <div className="relative flex justify-center text-xs uppercase">
          <span className="bg-background px-4 text-muted-foreground font-medium">
            Or continue with
          </span>
        </div>
      </div>

      {/* Social Login Buttons */}
      <div className="grid grid-cols-2 gap-4">
        <Button
          type="button"
          variant="outline"
          onClick={() => handleSocialLogin('google')}
          disabled={loading === 'google'}
          className="flex items-center justify-center space-x-2 py-3"
        >
          <Icon name="Chrome" size={20} />
          <span>{loading === 'google' ? 'Loading...' : 'Google'}</span>
        </Button>
        
        <Button
          type="button"
          variant="outline"
          onClick={() => handleSocialLogin('apple')}
          disabled={loading === 'apple'}
          className="flex items-center justify-center space-x-2 py-3"
        >
          <Icon name="Apple" size={20} />
          <span>{loading === 'apple' ? 'Loading...' : 'Apple'}</span>
        </Button>
      </div>
    </div>
  );
};

export default SocialLogin;